import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { useGetTransactionFilter, useShowTag } from "../../hooks/useCrm";
import { SimpleSelect1 } from "../../components/SimpleSelect/SimpleSelect1";
import { TagSelection } from "../../data/crmGeneralData";
import { useRecoilState } from "recoil";
import { crmFilteredTransaction } from "../../shared/crm-filtered-transactions";
import { formatDate } from "../../utils/formatDate";
import { filterTradingList } from "../../shared/filterTradingList";
const initvalue = {
  FactorTag: "انتخاب کنید",
  IdMarketer: "انتخاب کنید",
  Start: "",
  End: "",
};
export const TransactionFilterModal = ({ show, handleClose, responsible }) => {
  const [form, setForm] = useState(initvalue);
  const [filters, setFilters] = useRecoilState(filterTradingList);
  const [marketerName, setMarketerName] = useState();
  const [button] = useState(false);
  const [data, setData] = useRecoilState(crmFilteredTransaction);
  const { data: tags } = useShowTag();
  const {
    data: tradesfiltered,
    isFetchingNextPage,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetTransactionFilter(form);
  const tagsOptions = tags?.data?.tags?.map((tag) => {
    return {
      value: tag.NameTag,
      label: tag.NameTag,
    };
  });

  useEffect(() => {
    setData(tradesfiltered);
  }, [tradesfiltered]);

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;

        if (hasNextPage) await fetchNextPage();

        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  return (
    <BootstrapModal
      modaltitle="فیلتر معاملات"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            res={tagsOptions}
            label="برچسب"
            onChange={(e) => {
              setForm({ ...form, FactorTag: e.value });
              setFilters({ ...filters, FactorTag: e.value });
            }}
            placeholder={form.FactorTag}
          />
        </div>
        <div className="col-6">
          <DataPicker
            label="ابتدای بازه"
            onChange={(event) => {
              setForm({ ...form, Start: formatDate(event) });
              setFilters({ ...filters, Start: formatDate(event) });
            }}
            className="form-control"
          />
        </div>
        <div className="col-6">
          <DataPicker
            label="انتهای بازه"
            onChange={(event) => {
              setForm({ ...form, End: formatDate(event) });
              setFilters({ ...filters, End: formatDate(event) });
            }}
            className="form-control"
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="مسئول"
            res={responsible}
            onChange={(e) => {
              setForm({ ...form, IdMarketer: e.value });
              setFilters({ ...filters, IdMarketer: e.value });
              setMarketerName(e.label);
            }}
            placeholder={marketerName}
          />
        </div>
        <div className="col-6">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              setData(tradesfiltered);
              handleClose();
            }}
          >
            {!isLoading ? "تایید" : "در حال بارگزاری"}
          </Button>
        </div>
        <div className="col-6">
          <Button
            bgColor="#dc3847"
            color="#fff"
            onclick={() => {
              handleClose();
              setForm(initvalue);
              setFilters(null);
              setData(null);
            }}
          >
            حذف فیلترها
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
